<div class="container siteContainer" fxLayout="column">
  <app-header [title]="title" [currentView]="currentView" (currentViewClick)="onCurrentViewClick($event)"></app-header>
  <div class="container contentContainer" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
    <section fxFlex="13%" fxFlexOrder="1" fxFlexOrder.lt-md="3"></section>
    <section class="viewContainer" fxFlexOrder="2" fxFlexOrder.lt-md="2">
      <app-portfolio *ngIf="currentView === 'portfolio'"></app-portfolio>
      <app-links-view *ngIf="currentView === 'links'"></app-links-view>
    </section>
    <section id="sidebar" class="sidebarContainer" fxFlex="19%" fxFlexOrder="3" fxFlexOrder.lt-md="1">
      <app-sidebar></app-sidebar>
    </section>
    <section fxFlex="12%" fxFlexOrder="4"></section>
  </div>
  <app-footer></app-footer>
</div>
